(function(){
  'use strict';
  function __ready(fn){
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

    // ============================================================
  // Header is-scrolled class for styling
  // ============================================================
let lastScroll = 0;
const __onScroll = () => {
  const scrolled = window.scrollY > 40;
  const header = document.querySelector('.site-header');
  if (header && (scrolled !== header.classList.contains('is-scrolled'))) {
    header.classList.toggle('is-scrolled', scrolled);
  }
  lastScroll = window.scrollY;
};
window.addEventListener('scroll', __onScroll);
__ready(__onScroll);


  // ============================================================
  // Header højde som top margin til Main content så det ikke bliver dækket af den sticky header
  // ============================================================

  let __headerHeight = 0;

  const __applyHeaderHeight = (height) => {
    if (height === __headerHeight || height === 0) return;
    __headerHeight = height;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
    // margin-top på MainContent så indholdet ikke dækkes af headeren
    const mainContent = document.getElementById('MainContent');
    if (mainContent) mainContent.style.marginTop = `${height}px`;
  };

  const __updateHeaderHeight = () => {
    const header = document.querySelector('.site-header');
    if (!header) return;

    // Ved scroll kollapser topbaren, rækkerne strammes ind og logoet
    // krymper. MainContent skal beholde afstanden fra den FULDE header —
    // ellers ville marginen skrumpe midt i en scroll og siden hoppe.
    if (!header.classList.contains('is-scrolled')) {
      __applyHeaderHeight(header.offsetHeight);
      return;
    }

    // Loades siden midt på (refresh eller ankerlink) er is-scrolled sat
    // allerede, og den fulde højde er aldrig blevet målt. Mål den én gang
    // med klassen slået fra; --measuring undertrykker overgangene, så
    // krympningen ikke blinker.
    if (__headerHeight !== 0) return;
    header.classList.add('site-header--measuring');
    header.classList.remove('is-scrolled');
    const fullHeight = header.offsetHeight;
    header.classList.add('is-scrolled');
    void header.offsetHeight;
    header.classList.remove('site-header--measuring');
    __applyHeaderHeight(fullHeight);
  };
  window.addEventListener('resize', __updateHeaderHeight);
  __ready(__updateHeaderHeight);
  // Genberegn når headeren skifter højde — fx når topbaren slås til/fra
  // i theme editoren, eller når indholdet ombrydes på smalle skærme.
  document.addEventListener('shopify:section:load', __updateHeaderHeight);
  __ready(() => {
    const header = document.querySelector('.site-header');
    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(__updateHeaderHeight).observe(header);
    }
  });

  // ============================================================
  // Topbarens naturlige højde — bruges af CSS til at kollapse den
  // væk ved scroll (max-height: var(--topbar-height) → 0).
  // scrollHeight virker selv når elementet er kollapset.
  // ============================================================

  const __updateTopbarHeight = () => {
    const header = document.querySelector('.site-header');
    const topbar = header && header.querySelector('.site-topbar');
    if (!topbar) return;
    const height = topbar.scrollHeight;
    if (height > 0) header.style.setProperty('--topbar-height', `${height}px`);
  };
  window.addEventListener('resize', __updateTopbarHeight);
  __ready(__updateTopbarHeight);
  document.addEventListener('shopify:section:load', __updateTopbarHeight);


  // ============================================================
  // Hero-baggrundsvideo
  // Kilderne ligger i data-src og flyttes først til src når videoen
  // faktisk må spille. Så henter mobil og "reducér bevægelse" aldrig
  // filen — de får posterbilledet, som ligger under videoen.
  // ============================================================

  const __initHeroVideo = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video[data-hero-video]').forEach((video) => {
      if (video.dataset.heroVideoInit === '1') return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (video.dataset.heroVideoDesktopOnly === 'true'
        && window.matchMedia('(max-width: 767px)').matches) return;

      const sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;

      video.dataset.heroVideoInit = '1';
      sources.forEach((source) => { source.src = source.dataset.src; });
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      video.load();

      const started = video.play();
      // Autoplay kan afvises af browseren — så bliver posterbilledet stående.
      if (started && typeof started.catch === 'function') started.catch(() => {});
    });
  };
  __ready(() => __initHeroVideo(document));
  // Resize fanger den der starter smalt og gør vinduet bredere;
  // dataset-flaget sikrer at hver video kun initialiseres én gang.
  window.addEventListener('resize', () => __initHeroVideo(document));
  document.addEventListener('shopify:section:load', (e) => __initHeroVideo(e.target || document));


  // ============================================================
  // Hover-kontrast: sikrer læsbar tekst når knapper får hover-fyld
  // ============================================================
  const __parseColor = (str) => {
    if (!str) return null;
    const s = str.trim();
    const m = s.match(/^rgba?\(([^)]+)\)$/i);
    if (m) {
      const parts = m[1].split(/[ ,/]+/).filter(Boolean).map(Number);
      if (parts.length >= 3) return [parts[0], parts[1], parts[2]];
    }
    const h = s.match(/^#([0-9a-f]{3,8})$/i);
    if (h) {
      let hex = h[1];
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
      if (hex.length >= 6) {
        return [parseInt(hex.slice(0,2),16), parseInt(hex.slice(2,4),16), parseInt(hex.slice(4,6),16)];
      }
    }
    return null;
  };
  const __mix = (a, b, r) => [Math.round(a[0]*r+b[0]*(1-r)), Math.round(a[1]*r+b[1]*(1-r)), Math.round(a[2]*r+b[2]*(1-r))];
  const __lum = ([r,g,b]) => {
    const f = (c) => { const v = c/255; return v <= 0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055, 2.4); };
    return 0.2126*f(r) + 0.7152*f(g) + 0.0722*f(b);
  };
  const __ratio = (a, b) => { const l1=__lum(a), l2=__lum(b); const [hi,lo] = l1>l2?[l1,l2]:[l2,l1]; return (hi+0.05)/(lo+0.05); };
  const __adjustBtn = (btn) => {
    if (!btn || btn.dataset.hoverContrastChecked === '1') return;
    const cs = getComputedStyle(btn);
    const bg = __parseColor(cs.backgroundColor);
    const fg = __parseColor(cs.color);
    if (!fg) return;
    btn.dataset.hoverContrastChecked = '1';
    let hoverBg;
    const transparent = !bg || cs.backgroundColor === 'rgba(0, 0, 0, 0)' || cs.backgroundColor === 'transparent';
    if (transparent) {
      const tmp = document.createElement('div');
      tmp.style.cssText = 'position:absolute;visibility:hidden;background:hsl(var(--muted))';
      document.body.appendChild(tmp);
      hoverBg = __parseColor(getComputedStyle(tmp).backgroundColor) || [240,240,240];
      document.body.removeChild(tmp);
    } else {
      hoverBg = __mix(bg, [0,0,0], 0.88);
    }
    if (__ratio(hoverBg, fg) >= 4.5) return;
    const white = [255,255,255], black = [17,17,17];
    btn.style.setProperty('--btn-hover-text', __ratio(hoverBg, white) >= __ratio(hoverBg, black) ? '#ffffff' : '#111111');
  };
  const __scanBtns = (root) => {
    const scope = root || document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('.btn, .btn-primary, .btn-secondary, .btn-outline').forEach(__adjustBtn);
  };
  const __initHoverContrast = () => {
    __scanBtns(document);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver((muts) => {
        for (const m of muts) m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('.btn, .btn-primary, .btn-secondary, .btn-outline')) __adjustBtn(n);
          __scanBtns(n);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', (e) => __scanBtns(e.target || document));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', __initHoverContrast);
  else __initHoverContrast();

  const DEFAULT_EXTRA_FACTOR = 1.15;
  const DEFAULT_DENSITIES = {
    sand: 1.5,
    grus: 1.7,
    sten: 1.6,
    jord: 1.2,
  };

  const formatNumber = (value, decimals = 2) => {
    const safeValue = Number.isFinite(value) ? value : 0;
    return new Intl.NumberFormat('da-DK', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(safeValue);
  };

  const parseNumber = (value) => {
    if (!value) return 0;
    return parseFloat(String(value).replace(',', '.')) || 0;
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector(button.getAttribute('data-menu-toggle'));
      if (!target) return;
      const open = target.classList.toggle('open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Mobile nav: toggle submenus (div version, accessible)
  document.addEventListener('click', function(e) {
    const div = e.target.closest('.mobile-nav__link--has-sub[data-mobile-nav-toggle]');
    if (div && div.tagName === 'DIV') {
      e.preventDefault();
      const subId = div.getAttribute('aria-controls');
      const sub = subId && document.getElementById(subId);
      const isOpen = div.classList.toggle('mobile-nav__link--open');
      div.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (sub) {
        sub.hidden = !isOpen;
      }
      // Close other open submenus at same level
      const siblings = Array.from(div.parentNode.querySelectorAll('.mobile-nav__link--has-sub[data-mobile-nav-toggle]'));
      siblings.forEach(function(sib) {
        if (sib !== div) {
          sib.classList.remove('mobile-nav__link--open');
          sib.setAttribute('aria-expanded', 'false');
          const sibSubId = sib.getAttribute('aria-controls');
          const sibSub = sibSubId && document.getElementById(sibSubId);
          if (sibSub) sibSub.hidden = true;
        }
      });
    }
    // Handle parent link click in sub dropdown
    const parentLink = e.target.closest('.mobile-nav__sublink--parent');
    if (parentLink) {
      // Close the sub dropdown
      const sub = parentLink.closest('.mobile-nav__sub');
      if (sub) {
        sub.hidden = true;
        // Find the corresponding nav link and close it
        const subId = sub.id;
        if (subId) {
          const navLink = document.querySelector('[aria-controls="' + subId + '"]');
          if (navLink) {
            navLink.classList.remove('mobile-nav__link--open');
            navLink.setAttribute('aria-expanded', 'false');
          }
        }
      }
    }
  });

  document.querySelectorAll('[data-calc]').forEach((root) => {
    const depthEl = root.querySelector('[data-calc-depth]');
    const widthEl = root.querySelector('[data-calc-width]');
    const lengthEl = root.querySelector('[data-calc-length]');
    const m3El = root.querySelector('[data-calc-m3]');
    const sandEl = root.querySelector('[data-calc-sand]');
    const grusEl = root.querySelector('[data-calc-grus]');
    const stenEl = root.querySelector('[data-calc-sten]');
    const jordEl = root.querySelector('[data-calc-jord]');
    const cta = root.querySelector('[data-calc-cta]');

    const syncLeadFields = (values) => {
      document.querySelectorAll('[data-lead-form]').forEach((form) => {
        const setValue = (name, value) => {
          const field = form.querySelector(`input[name="contact[${name}]"]`);
          if (field) field.value = value;
        };

        setValue('Beregner_hoejde', values.depthRaw);
        setValue('Beregner_bredde', values.widthRaw);
        setValue('Beregner_laengde', values.lengthRaw);
        setValue('Beregner_m3', values.volumeFormatted);
        setValue('Beregner_sand_ton', values.sandFormatted);
        setValue('Beregner_grus_ton', values.grusFormatted);
        setValue('Beregner_sten_ton', values.stenFormatted);
        setValue('Beregner_jord_ton', values.jordFormatted);
      });
    };

    const extraFactor = parseNumber(root.dataset.extraFactor) || DEFAULT_EXTRA_FACTOR;
    const densities = {
      sand: parseNumber(root.dataset.densitySand) || DEFAULT_DENSITIES.sand,
      grus: parseNumber(root.dataset.densityGrus) || DEFAULT_DENSITIES.grus,
      sten: parseNumber(root.dataset.densitySten) || DEFAULT_DENSITIES.sten,
      jord: parseNumber(root.dataset.densityJord) || DEFAULT_DENSITIES.jord,
    };

    const recalc = () => {
      const depth = parseNumber(depthEl && depthEl.value);
      const width = parseNumber(widthEl && widthEl.value);
      const length = parseNumber(lengthEl && lengthEl.value);
      const baseVolume = depth * width * length;
      const volume = baseVolume > 0 ? baseVolume * extraFactor : 0;

      // Materialevægt = baseVolume × densitet × multiplikator.
      // Densitetsfeltet er resultatet for 1×1×1 m ved multiplikator = 1.0,
      // så når multiplikatoren ændres, ganges den også på materialevægtene.
      const sand = volume * densities.sand;
      const grus = volume * densities.grus;
      const sten = volume * densities.sten;
      const jord = volume * densities.jord;

      const volumeFormatted = formatNumber(baseVolume);
      const sandFormatted = formatNumber(sand);
      const grusFormatted = formatNumber(grus);
      const stenFormatted = formatNumber(sten);
      const jordFormatted = formatNumber(jord);

      if (m3El) m3El.textContent = volumeFormatted;
      if (sandEl) sandEl.textContent = sandFormatted;
      if (grusEl) grusEl.textContent = grusFormatted;
      if (stenEl) stenEl.textContent = stenFormatted;
      if (jordEl) jordEl.textContent = jordFormatted;

      syncLeadFields({
        depthRaw: depthEl ? depthEl.value : '',
        widthRaw: widthEl ? widthEl.value : '',
        lengthRaw: lengthEl ? lengthEl.value : '',
        volumeFormatted,
        sandFormatted,
        grusFormatted,
        stenFormatted,
        jordFormatted,
      });
    };

    [depthEl, widthEl, lengthEl].forEach((field) => {
      if (field) field.addEventListener('input', recalc);
    });

    recalc();

    // Helper to show calc summary above the lead form
      function showLeadCalcSummary() {
        const lead = document.getElementById('tilbud') || document.getElementById('lead-form');
        if (!lead) return;
        const summary = lead.querySelector('#lead-calc-summary');
        if (!summary) return;
        // Group fields: inputs and results
        const inputFields = [
          { name: 'Beregner_hoejde', label: 'Højde (m)' },
          { name: 'Beregner_bredde', label: 'Bredde (m)' },
          { name: 'Beregner_laengde', label: 'Længde (m)' },
        ];
        const resultFields = [
          { name: 'Beregner_m3', label: 'Volumen (m³)' },
          { name: 'Beregner_sand_ton', label: 'Sand (ton)' },
          { name: 'Beregner_grus_ton', label: 'Grus (ton)' },
          { name: 'Beregner_sten_ton', label: 'Sten (ton)' },
          { name: 'Beregner_jord_ton', label: 'Jord (ton)' },
        ];
        const getValues = (fields) => fields.map(f => {
          var input = lead.querySelector('input[name="contact[' + f.name + ']"]');
          return input && input.value ? { label: f.label, value: input.value } : null;
        }).filter(Boolean);
        const inputs = getValues(inputFields);
        const results = getValues(resultFields);
        if (inputs.length === 0 && results.length === 0) {
          summary.style.display = 'none';
          summary.innerHTML = '';
          return;
        }
        summary.style.display = '';
        summary.innerHTML = `
          <div style="background:var(--muted);border-radius:8px;padding:.7rem 1.1rem;display:flex;flex-wrap:wrap;gap:1.1rem 2rem;align-items:flex-start;justify-content:flex-start;font-size:.93em;">
            ${inputs.length ? `
              <div style="display:flex;flex-direction:column;gap:.2rem .7rem;min-width:110px;">
                <div style="font-weight:600;font-size:.92em;margin-bottom:.15em;opacity:.7;letter-spacing:.01em;">Indtastede mål</div>
                ${inputs.map(v => `
                  <div><span style="font-weight:500;">${v.label}:</span> <span>${v.value}</span></div>
                `).join('')}
              </div>
            ` : ''}
            ${results.length ? `
              <div style="display:flex;flex-direction:column;gap:.2rem .7rem;min-width:110px;">
                <div style="font-weight:600;font-size:.92em;margin-bottom:.15em;opacity:.7;letter-spacing:.01em;">Beregnet resultat</div>
                ${results.map(v => `
                  <div><span style="font-weight:500;">${v.label}:</span> <span>${v.value}</span></div>
                `).join('')}
              </div>
            ` : ''}
          </div>
        `;
      }

    if (cta) {
      cta.addEventListener('click', () => {
        const lead = document.getElementById('tilbud') || document.getElementById('lead-form');
        if (lead) {
          showLeadCalcSummary();
          lead.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  });

  document.querySelectorAll('[data-variant-form]').forEach((form) => {
    const productScope = form.closest('.product') || document;
    const variantsScript = productScope.querySelector('[data-product-variants]');
    let variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent || '[]'); }
      catch (err) { console.error('variant JSON parse fejl', err); }
    }
    const priceEl = productScope.querySelector('[data-product-price]');
    const variantIdInput = productScope.querySelector('[data-product-variant-id]');
    const buyBtn = productScope.querySelector('[data-product-buy-btn]');
    const drawerEl = document.querySelector('[data-cart-drawer]');
    const moneyFmt = (drawerEl && drawerEl.dataset && drawerEl.dataset.moneyFormat) || '{{amount}} kr';
    const formatPrice = (cents) => {
      const amount = (Number(cents) || 0) / 100;
      const formatted = amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, formatted);
    };

    const sync = () => {
      const data = {};
      const optionValues = [];
      form.querySelectorAll('select, input[type="radio"]:checked').forEach((el) => {
        if (el.name) data[el.dataset.optionName || el.name] = el.value;
        const pos = parseInt(el.dataset.optionPosition || '', 10);
        if (pos) optionValues[pos - 1] = el.value;
      });
      document.querySelectorAll('[data-lead-form]').forEach((lead) => {
        Object.entries(data).forEach(([key, value]) => {
          const field = lead.querySelector(`input[name="contact[${key}]"]`);
          if (field) field.value = value;
        });
      });

      // Find matching variant + opdater pris/buy-btn
      if (variants.length && optionValues.length) {
        const match = variants.find((v) => {
          for (let i = 0; i < optionValues.length; i++) {
            if (v['option' + (i + 1)] !== optionValues[i]) return false;
          }
          return true;
        });
        if (match) {
          if (priceEl) {
            let html = formatPrice(match.price);
            if (match.compare_at_price && match.compare_at_price > match.price) {
              html += ` <span class="product__price-compare">${formatPrice(match.compare_at_price)}</span>`;
            }
            priceEl.innerHTML = html;
          }
          if (variantIdInput) variantIdInput.value = match.id;
          if (buyBtn) {
            buyBtn.disabled = !match.available;
          }
        }
      }
    };
    form.addEventListener('change', sync);
    sync();
  });

  document.querySelectorAll('[data-lead-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const honeypot = form.querySelector('input[name="contact[website]"]');
      if (honeypot && honeypot.value) event.preventDefault();
    });
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    const body = drawer.querySelector('[data-cart-drawer-body]');
    const overlay = drawer.querySelector('[data-cart-close-overlay]');
    const closeButtons = drawer.querySelectorAll('[data-cart-close]');
    const openButtons = document.querySelectorAll('[data-cart-open]');
    const countEls = document.querySelectorAll('[data-cart-count]');

    const labels = {
      empty: drawer.dataset.emptyLabel || 'Din kurv er tom.',
      remove: drawer.dataset.removeLabel || 'Fjern',
      subtotal: drawer.dataset.subtotalLabel || 'Subtotal',
      vat: drawer.dataset.vatLabel || 'heraf moms (25%)',
      total: drawer.dataset.totalLabel || 'I alt',
    };
    const moneyFormat = drawer.dataset.moneyFormat || '{{amount}} kr';

    const formatMoney = (cents) => {
      const amount = (Number(cents) || 0) / 100;
      const formatted = amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, formatted);
    };

    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    const vatEl = drawer.querySelector('[data-cart-vat]');
    const totalEl = drawer.querySelector('[data-cart-total]');
    const footerEl = drawer.querySelector('[data-cart-footer]');

    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('cart-open', open);
      if (open) {
        const firstField = drawer.querySelector('[data-cart-close]');
        if (firstField) firstField.focus({ preventScroll: true });
      }
    };

    const updateCount = (count) => {
      countEls.forEach((el) => {
        el.textContent = String(count || 0);
        el.hidden = !count;
      });
    };

    const updateTotals = (cart) => {
      const total = (cart && cart.total_price) || 0;
      const vat = Math.round(total * 0.20);
      if (subtotalEl) subtotalEl.textContent = formatMoney(total);
      if (vatEl) vatEl.textContent = formatMoney(vat);
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (footerEl) footerEl.hidden = !total;
    };

    const renderCart = (cart) => {
      updateCount(cart && cart.item_count ? cart.item_count : 0);
      updateTotals(cart);
      if (!body) return;

      if (!cart || !cart.items || !cart.items.length) {
        let cartFooter = document.querySelector('[data-cart-footer]');
        if (cartFooter) cartFooter.classList.add('hidden');
        body.innerHTML = `<div class="drawer-empty">${escapeHtml(labels.empty)}</div>`;
        return;
      }

      body.innerHTML = cart.items.map((item) => {
        const image = item.featured_image && item.featured_image.url
          ? `<div class="cart-drawer__line-image"><img src="${escapeHtml(item.featured_image.url)}" alt="${escapeHtml(item.product_title)}" loading="lazy"></div>`
          : `<div class="cart-drawer__line-image"></div>`;

        const variantBit = item.variant_title && item.variant_title !== 'Default Title'
          ? `${escapeHtml(item.variant_title)}<br>`
          : '';
        const linePrice = formatMoney(item.final_line_price);
        const unitNote = item.quantity > 1
          ? ` <span class="muted">(${formatMoney(item.final_price)} / stk.)</span>`
          : '';

        return `
          <div class="cart-drawer__line" data-line-key="${escapeHtml(item.key)}">
            ${image}
            <div>
              <a href="${escapeHtml(item.url || '#')}" class="cart-drawer__line-title font-display">${escapeHtml(item.product_title)}</a>
              <div class="cart-drawer__line-meta">
                ${variantBit}<strong class="cart-drawer__line-price">${linePrice}</strong>${unitNote}
              </div>
              <div class="cart-drawer__line-actions">
                <button type="button" class="cart-drawer__remove" data-cart-remove data-line-key="${escapeHtml(item.key)}">${escapeHtml(labels.remove)}</button>
              </div>
            </div>
          </div>
        `;
      }).join('');
    };

    const fetchCart = async () => {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Kunne ikke hente kurven');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const changeLine = async (key, quantity) => {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error('Kunne ikke opdatere kurven');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        setOpen(true);
        try {
          await fetchCart();
        } catch (error) {
          console.error(error);
        }
      });
    });

    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    if (overlay) overlay.addEventListener('click', () => setOpen(false));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    drawer.addEventListener('click', async (event) => {
      const removeButton = event.target.closest('[data-cart-remove]');
      if (!removeButton) return;
      try {
        await changeLine(removeButton.dataset.lineKey, 0);
      } catch (error) {
        console.error(error);
      }
    });

    updateCount(parseInt(drawer.dataset.initialCount || '0', 10) || 0);
  }

  // Samtykke-validering for kurv-CTA (drawer + /cart-side)
  document.querySelectorAll('[data-cart-checkout-cta]').forEach((cta) => {
    cta.addEventListener('click', (event) => {
      const scope = cta.closest('.cart-drawer, .cart-summary, .cart-page') || document;

      let invalidField = null;
      const consent = scope.querySelector('[data-cart-consent]');
      if (consent && !consent.checked) {
        event.preventDefault();
        const wrapper = scope.querySelector('[data-cart-consent-wrapper]');
        const error = scope.querySelector('[data-cart-consent-error]');
        if (wrapper) wrapper.classList.add('cart-consent--invalid');
        if (error) error.hidden = false;
        invalidField = consent;
      }

      const fortovOptions = scope.querySelectorAll('[data-pn-fortov]');
      if (fortovOptions.length && ![...fortovOptions].some((input) => input.checked)) {
        event.preventDefault();
        const wrapper = scope.querySelector('[data-pn-fortov-wrapper]');
        const error = scope.querySelector('[data-pn-fortov-error]');
        if (wrapper) wrapper.classList.add('cart-consent--invalid');
        if (error) error.hidden = false;
        if (!invalidField) invalidField = fortovOptions[0];
      }

      if (invalidField) {
        invalidField.focus();
      }
    });
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || !target.matches) return;

    if (target.matches('[data-cart-consent]') && target.checked) {
      const scope = target.closest('.cart-drawer, .cart-summary, .cart-page') || document;
      const wrapper = scope.querySelector('[data-cart-consent-wrapper]');
      const error = scope.querySelector('[data-cart-consent-error]');
      if (wrapper) wrapper.classList.remove('cart-consent--invalid');
      if (error) error.hidden = true;
    }

    if (target.matches('[data-pn-fortov]')) {
      const scope = target.closest('.cart-drawer, .cart-summary, .cart-page') || document;
      const wrapper = scope.querySelector('[data-pn-fortov-wrapper]');
      const error = scope.querySelector('[data-pn-fortov-error]');
      if (wrapper) wrapper.classList.remove('cart-consent--invalid');
      if (error) error.hidden = true;
    }
  });

  // ============================================================
  // Header dropdown — keyboard a11y (mouse via :hover i CSS)
  // ============================================================
  document.querySelectorAll('.site-nav__item--has-dropdown').forEach((item) => {
    const link = item.querySelector('.site-nav__link');
    if (!link) return;
    link.addEventListener('focus', () => link.setAttribute('aria-expanded', 'true'));
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) link.setAttribute('aria-expanded', 'false');
    });
  });

  // ============================================================
  // Header search — toggle + predictive
  // ============================================================
  const __search = document.querySelector('[data-search]');
  if (__search) {
    const toggle = __search.querySelector('[data-search-toggle]');
    const form = __search.querySelector('[data-search-form]');
    const input = __search.querySelector('[data-search-input]');
    const results = __search.querySelector('[data-search-results]');

    const setOpen = (open) => {
      __search.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && input) setTimeout(() => input.focus(), 50);
    };
    if (toggle) toggle.addEventListener('click', () => setOpen(!__search.classList.contains('is-open')));
    document.addEventListener('click', (e) => { if (!__search.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });

    let debounce;
    if (input && results) {
      input.addEventListener('input', () => {
        clearTimeout(debounce);
        const q = input.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        debounce = setTimeout(async () => {
          try {
            const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
            const res = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!res.ok) throw new Error('search failed');
            const data = await res.json();
            const items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) {
              results.innerHTML = `<div class="site-search__empty">Ingen resultater for "${q.replace(/[<>&"]/g, '')}".</div>`;
            } else {
              results.innerHTML = items.map((p) => {
                const img = p.image ? `<img src="${p.image}" alt="" loading="lazy">` : '<div style="width:44px;height:44px;background:var(--muted);border-radius:4px;"></div>';
                return `<a class="site-search__result" href="${p.url}">
                  ${img}
                  <div>
                    <div class="site-search__result-title">${p.title}</div>
                    ${p.vendor ? `<div class="site-search__result-meta">${p.vendor}</div>` : ''}
                  </div>
                </a>`;
              }).join('') + `<a class="site-search__view-all" href="/search?q=${encodeURIComponent(q)}">Vis alle resultater →</a>`;
            }
            results.hidden = false;
          } catch (err) {
            console.error(err);
          }
        }, 220);
      });
    }
  }

  // ============================================================
  // Produktside — galleri (klik på thumbnail skifter hovedbillede)
  // ============================================================
  __ready(function(){
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-product-main-image]');
    const thumbs = gallery.querySelectorAll('[data-product-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const url = thumb.dataset.imageUrl;
        const alt = thumb.dataset.imageAlt || '';
        if (url) {
          main.src = url;
          main.alt = alt;
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
    gallery.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      const arr = Array.from(thumbs);
      const idx = arr.findIndex((t) => t.classList.contains('is-active'));
      if (idx < 0) return;
      const next = e.key === 'ArrowRight' ? (idx + 1) % arr.length : (idx - 1 + arr.length) % arr.length;
      arr[next].click();
    });
  });
  });
})();
